import { Link } from 'react-router-dom'
import {
  Github,
  Linkedin,
  Instagram,
  MapPin,
  Phone,
  Shield,
} from 'lucide-react'
import { gtmEvents } from '@/lib/gtm'

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-200 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <div className="text-xl font-bold text-white flex items-center gap-2">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white font-mono">
                DP6
              </div>
              DP6.shop
            </div>
            <p className="text-sm text-slate-400">
              A loja oficial dos apaixonados por dados. Vista sua stack
              favorita.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Navegação</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-blue-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/shop"
                  className="hover:text-blue-400 transition-colors"
                >
                  Loja
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="hover:text-blue-400 transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/contato"
                  className="hover:text-blue-400 transition-colors"
                >
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Categorias</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/shop?category=Moletons"
                  className="hover:text-blue-400 transition-colors"
                >
                  Moletons
                </Link>
              </li>
              <li>
                <Link
                  to="/shop?category=Camisetas"
                  className="hover:text-blue-400 transition-colors"
                >
                  Camisetas
                </Link>
              </li>
              <li>
                <Link
                  to="/shop?category=Canecas"
                  className="hover:text-blue-400 transition-colors"
                >
                  Canecas
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contato</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="tel:+5511999999999"
                  className="flex items-center gap-2 hover:text-blue-400 transition-colors"
                  onClick={() => gtmEvents.custom('click_phone')}
                >
                  <Phone className="h-4 w-4" /> (11) 99999-9999
                </a>
              </li>
              <li>
                <a
                  href="https://maps.google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 hover:text-blue-400 transition-colors"
                  onClick={() => gtmEvents.custom('click_map')}
                >
                  <MapPin className="h-4 w-4" /> Pinheiros, São Paulo - SP
                </a>
              </li>
              <li className="flex gap-4 mt-4">
                <a
                  href="#"
                  className="hover:text-white text-slate-400 transition-colors"
                  aria-label="LinkedIn"
                >
                  <Linkedin className="h-5 w-5" />
                </a>
                <a
                  href="#"
                  className="hover:text-white text-slate-400 transition-colors"
                  aria-label="GitHub"
                >
                  <Github className="h-5 w-5" />
                </a>
                <a
                  href="#"
                  className="hover:text-white text-slate-400 transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram className="h-5 w-5" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-slate-500">
          <p>
            © {new Date().getFullYear()} DP6.shop. Demo Site for GTM Testing.
          </p>
          <div className="mt-4 md:mt-0">
            <Link
              to="/admin"
              className="flex items-center gap-1 hover:text-slate-300"
            >
              <Shield className="h-3 w-3" /> Admin Area
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
